<div>
    <div style="height: 150px;" ng-if="!vm.widget.settingsVisible">
        <c-list class="listing" config="vm.listConfig"></c-list>
        <div class="total-count">
            <span class="title">{{"startPage.bucket.total" | translate}}</span>
            <div class="sum"><span class="sum"> {{vm.total}}</span></div>
            <div class="spacer"></div>
        </div>
    </div>
</div>
<div ng-if="vm.widget.settingsVisible" class="settingsContent properties">
    <div class="property-item" ng-if="vm.workUnits.length !== 0">
        <label>{{"startPage.workUnit" | translate}}:</label>
        <div c-select options="vm.workUnits" selected-option="vm.workUnit" validation="false"></div>
    </div>
    <div class="property-item">
        <label>{{"startPage.sort.order" | translate}}</label>
        <div c-select options="vm.widget.sorts" selected-option="vm.widget.orderBy"></div>
    </div>
</div>